import { NavItemBaseProps } from 'components';

export const invitesPrefix = '/invites';

export enum URL {
  AddDateOfBirth = '/add-dob',
  AcceptInvitation = '/accept-invitation',
  AccountSecurity = '/sign-up-account-security',
  AccountSetup = '/account-setup',
  AccountSetupComplete = '/account-setup/complete',
  AccountSetupNotifications = '/account-setup/notifications',
  AccountSetupPaymentMethod = '/account-setup/payment-method',
  AccountSetupAvatar = '/account-setup/profile-photo',
  AccountSetupRecoveryAccount = '/account-setup/recovery-account',
  AccountSetupAddMissingIdentity = '/account-setup/add-identity',
  AddEmployee = '/users/add-user',
  Dashboard = '/dashboard',
  Employees = '/users',
  EmployeeDetail = '/users/:id',
  EmployeePayoutDetails = '/payouts',
  EmployeesNeedingApproval = '/users/review',
  Error = '/error',
  Login = '/login',
  Join = '/join',
  LaborReview = '/labor-review',
  MakePayment = '/payments/make-payment',

  MakePaymentStandard = '/payments/make-payment/standard',
  MakePaymentStandardSelectDate = '/payments/make-payment/standard/select-date',
  MakePaymentStandardPayees = '/payments/make-payment/standard/select-payees',
  MakePaymentStandardInput = '/payments/make-payment/standard/input',
  MakePaymentStandardReview = '/payments/make-payment/standard/review',

  MakePaymentUpload = '/payments/make-payment/upload',
  MakePaymentUploadSelectDate = '/payments/make-payment/upload/select-date',
  MakePaymentUploadFile = '/payments/make-payment/upload/file',
  MakePaymentUploadInput = '/payments/make-payment/upload/input',
  MakePaymentUploadReview = '/payments/make-payment/upload/review',

  /** TIP CALC ROUTES */
  MakePaymentCalculator = '/payments/make-payment/calculator',
  MakePaymentCalculatorDate = '/payments/make-payment/calculator/select-date',
  MakePaymentCalculatorPools = '/payments/make-payment/calculator/pools',
  MakePaymentCalculatorOtherContributors = '/payments/make-payment/calculator/other-contributors',
  MakePaymentCalculatorChecks = '/payments/make-payment/calculator/checks',
  MakePaymentCalculatorLaborData = '/payments/make-payment/calculator/labor-data',
  MakePaymentCalculatorChangeLog = '/payments/make-payment/calculator/change-log',
  MakePaymentCalculatorTipAmounts = '/payments/make-payment/calculator/tip-data',
  MakePaymentCalculatorReview = '/payments/make-payment/calculator/review',

  MakePaymentSummary = '/payments/summary',
  NotFound = '/404',
  PaymentsDetail = '/payments/detail',
  PaymentsOverview = '/payments/overview',
  PaymentsReview = '/payments/review',
  PaymentSet = '/payments/payment-set/:id',
  RemoteSession = '/remote/session/:token',
  Reports = '/reports',
  ReportsAchHistory = '/reports/ach-history',
  ReportsBankReconciliation = '/reports/bank-reconciliation',
  ReportsLedger = '/reports/ledger',
  ReportsPaidPayments = '/reports/paid-payments',
  ReportsPayPeriod = '/reports/pay-period',
  ReportsEmployeePayPeriod = '/reports/employee-pay-period',
  ResetPassword = '/reset-password',
  RootPrivate = '/',
  RootPublic = '/login',
  SettingsAccount = '/settings/account',
  SettingsPaymentMethod = '/settings/payment-method',
  SettingsNotifications = '/settings/notifications',
  SettingsCalculator = '/settings/site/calculator',
  SettingsDaySegments = '/settings/site/day-segments',
  SettingsWithholdings = '/settings/site/withholdings',
  SettingsIntegrations = '/settings/site/integrations',
  SignUp = '/sign-up',
  SignUpEmail = '/sign-up-email',
  Sites = '/sites',
  TermsOfUse = '/payment_recipient_terms_of_use',
  Users = '/users',

  ConnectIntegrationLogin = '/connect/:integration',
  ConnectIntegrationConnections = '/connect/:integration/connections',
  ConnectIntegrationCallback = '/connect/:integration/callback',
  ConnectIntegrationSuccess = '/connect/:integration/success',

  McpConnect = '/mcp-connect',
}

const routeConstants = {
  private: {
    rootPath: URL.RootPrivate,
    addDOB: URL.AddDateOfBirth,
    acceptInvitationAccepted: `${URL.AcceptInvitation}?status=accepted`,
    acceptInvitationActionRequired: `${URL.AcceptInvitation}?status=action-required`,
    acceptInvitation: URL.AcceptInvitation,
    accountSetup: {
      avatar: URL.AccountSetupAvatar,
      complete: URL.AccountSetupComplete,
      notifications: URL.AccountSetupNotifications,
      paymentMethod: URL.AccountSetupPaymentMethod,
      recovery: URL.AccountSetupRecoveryAccount,
      missingIdentity: URL.AccountSetupAddMissingIdentity,
    },
    addEmployee: URL.AddEmployee,
    dashboard: URL.Dashboard,
    employees: URL.Employees,
    employeeDetail: URL.EmployeeDetail,
    employeePayoutDetails: URL.EmployeePayoutDetails,
    employeesNeedingApproval: URL.EmployeesNeedingApproval,
    laborReview: URL.LaborReview,
    makePayment: URL.MakePayment,
    makePaymentStandard: URL.MakePaymentStandard,
    makePaymentUpload: URL.MakePaymentUpload,
    makePaymentStandardSelectDate: URL.MakePaymentStandardSelectDate,
    makePaymentUploadSelectDate: URL.MakePaymentUploadSelectDate,

    /** TIP CALC ROUTES */
    makePaymentCalculator: URL.MakePaymentCalculator,
    makePaymentCalculatorDate: URL.MakePaymentCalculatorDate,
    makePaymentCalculatorPools: URL.MakePaymentCalculatorPools,
    makePaymentCalculatorOtherContributors: URL.MakePaymentCalculatorOtherContributors,
    makePaymentCalculatorChecks: URL.MakePaymentCalculatorChecks,
    makePaymentCalculatorLaborData: URL.MakePaymentCalculatorLaborData,
    makePaymentCalculatorChangeLog: URL.MakePaymentCalculatorChangeLog,
    makePaymentCalculatorTipAmounts: URL.MakePaymentCalculatorTipAmounts,
    makePaymentCalculatorReview: URL.MakePaymentCalculatorReview,

    makePaymentSummary: URL.MakePaymentSummary,
    notFound: URL.NotFound,
    paymentSet: URL.PaymentSet,
    paymentsOverview: URL.PaymentsOverview,
    paymentsDetail: URL.PaymentsDetail,
    paymentsReview: URL.PaymentsReview,
    reports: URL.Reports,
    reportsAchHistory: URL.ReportsAchHistory,
    reportsBankReconciliation: URL.ReportsBankReconciliation,
    reportsLedger: URL.ReportsLedger,
    reportsPaidPayments: URL.ReportsPaidPayments,
    reportsPayrollTips: URL.ReportsPayPeriod,
    reportsEmployeePayrollTips: URL.ReportsEmployeePayPeriod,
    settingsAccount: URL.SettingsAccount,
    settingsPaymentMethod: URL.SettingsPaymentMethod,
    settingsNotifications: URL.SettingsNotifications,
    settingsCalculator: URL.SettingsCalculator,
    settingsDaySegments: URL.SettingsDaySegments,
    settingsWithholdings: URL.SettingsWithholdings,
    settingsIntegrations: URL.SettingsIntegrations,

    connectIntegration: {
      connections: URL.ConnectIntegrationConnections,
      callback: URL.ConnectIntegrationCallback,
      success: URL.ConnectIntegrationSuccess,
    },
  },
  public: {
    rootPath: URL.RootPublic,
    signUp: URL.SignUp,
    signUpEmail: URL.SignUpEmail,
    accountSecurity: URL.AccountSecurity,
    login: URL.Login,
    connectIntegrationLogin: URL.ConnectIntegrationLogin,
    resetPassword: URL.ResetPassword,
    resetPasswordCreateNew: `${URL.ResetPassword}/create-new-password`,
    error: URL.Error,
    invites: {
      resetPassword: `${invitesPrefix}${URL.ResetPassword}`,
      notFound: `${invitesPrefix}/not-found`,
      expired: `${invitesPrefix}/expired`,
      alreadyClaimed: `${invitesPrefix}/already-claimed`,
      invalid: `${invitesPrefix}/invalid`,
      login: `${invitesPrefix}/login`,
      invitesResetPassword: `${invitesPrefix}${URL.ResetPassword}`,
      resetPasswordCreateNew: `${invitesPrefix}${URL.ResetPassword}/create-new-password`,
      invitesRootPath: `${invitesPrefix}/join`,
      invitesRedirectGoogle: {
        login: `${invitesPrefix}${URL.Login}/google`,
      },
    },
    accountRecovery: {
      root: '/account-recovery',
      addMobileIdentity: '/account-recovery/add-identity',
    },
    redirectGoogle: {
      signUp: `${URL.SignUp}/google`,
      login: `${URL.Login}/google`,
      integrationLogin: `${URL.ConnectIntegrationLogin}/google`,
    },
    termsOfUse: URL.TermsOfUse,
    remoteSession: URL.RemoteSession,
    mcpConnect: URL.McpConnect,
  },
};

export const routeForUserId = (id: string) => `/users/${id}`;

export const routeForPaymentDetail = (id: string) => `/payments/payment-set/${id}`;

export default routeConstants;

export const adminNav: NavItemBaseProps[] = [
  {
    label: 'Dashboard',
    icon: 'HomeOutline',
    iconActive: 'Home',
    to: routeConstants.private.dashboard,
  },
  {
    label: 'Payments',
    icon: 'PaymentOutline',
    iconActive: 'Payment',
    to: routeConstants.private.paymentsOverview,
  },
  {
    label: 'Users',
    icon: 'PeopleOutline',
    iconActive: 'People',
    to: routeConstants.private.employees,
  },
  {
    label: 'Reports',
    icon: 'ReportOutline',
    iconActive: 'Report',
    to: routeConstants.private.reportsPaidPayments,
  },
  {
    label: 'Settings',
    icon: 'SettingsOutline',
    iconActive: 'Settings',
    to: routeConstants.private.settingsCalculator,
  },
];

export const employeeNav: NavItemBaseProps[] = [
  {
    label: 'Dashboard',
    icon: 'HomeOutline',
    iconActive: 'Home',
    to: routeConstants.private.dashboard,
  },
  {
    label: 'Settings',
    icon: 'SettingsOutline',
    iconActive: 'Settings',
    to: routeConstants.private.settingsAccount,
  },
];
